<template>
  <header>
    <b-navbar
      fixed="top"
      toggleable="md"
      class="header-component py-sm-1 py-xxs-2"
      :type="this.portalGeneralInfo.theme"
      :variant="this.portalGeneralInfo.theme"
    >
      <b-navbar-brand class="float-right d-none d-md-block" to="/">
        <b-img :src="portalGeneralInfo.logoUrl" class="logo d-inline-block align-top" :to="{name:'home'}"/>
      </b-navbar-brand>

      <b-navbar-nav is-nav="false" class="p-0 m-0 d-inline-block d-md-none">
        <b-nav-item v-if="!isUserLoggedIn && tenantLoginType === 'vas'" @click="showLogin">
          {{ $t('header.login') }}
        </b-nav-item>
        <b-nav-item
          v-if="isUserLoggedIn && showUnsubButton && tenantLoginType === 'vas'"
          class="ml-auto"
          @click="showUnsub"
        >
          {{ $t('header.unsub') }}
        </b-nav-item>
      </b-navbar-nav>

      <b-navbar-brand class="mx-auto   d-inline-block d-md-none" to="/">
        <b-img :src="portalGeneralInfo.logoUrl" class="logo align-top" :to="{name:'home'}"/>
      </b-navbar-brand>

      <b-navbar-nav class="m-0 p-0" left>
        <b-navbar-toggle target="nav_collapse" />
      </b-navbar-nav>
      <b-collapse id="nav_collapse" is-nav class="pl-4">
        <b-navbar-nav>
          <b-nav-item v-if="portalConfigurations.langFile" :to="{ name: 'home' }" exact>
            {{ portalConfigurations.langFile.header.home }}
          </b-nav-item>
          <b-nav-item v-else :to="{ name: 'home' }" exact>
            {{ $t('header.home') }}
          </b-nav-item>
          <b-nav-item
            :to="{ name: 'products' }"
            exact
          >
            {{ $t('header.productsList', {products: this.globalResources.productTranslation.Plural}) }}
          </b-nav-item>
          <b-nav-item v-if="!portalConfigurations.general.hasNoTerms" :to="{ name: 'terms' }" exact>
            {{ $t('header.termsAndConditions') }}
          </b-nav-item>
        </b-navbar-nav>
        <div class="dropdown-divider" />
        <b-navbar-nav class="d-md-none">
          <b-nav-item
            v-for="(collection, index) in collections"
            :key="index"
            :to="'/collection/' + collection.id"
            exact
          >
            {{ collection.name }}
          </b-nav-item>
        </b-navbar-nav>
        <div class="dropdown-divider" />
        <b-navbar-nav class="d-md-none">
          <b-nav-item v-if="!isUserLoggedIn && tenantLoginType === 'vas'" @click="showLogin">
            {{ $t('header.login') }}
          </b-nav-item>
          <b-nav-item
            v-if="isUserLoggedIn && showUnsubButton && tenantLoginType === 'vas'"
            @click="showUnsub"
          >
            {{ $t('header.unsub') }}
          </b-nav-item>
        </b-navbar-nav>
      </b-collapse>
      <b-navbar-nav is-nav="false" class="p-0 m-0 p-0 m-0 d-none d-md-block">
        <b-nav-item v-if="!isUserLoggedIn && tenantLoginType === 'vas'" @click="showLogin">
          {{ $t('header.login') }}
        </b-nav-item>
        <b-nav-item
          v-if="isUserLoggedIn && showUnsubButton && tenantLoginType === 'vas'"
          class="ml-auto"
          @click="showUnsub"
        >
          {{ $t('header.unsub') }}
        </b-nav-item>
      </b-navbar-nav>
    </b-navbar>
  </header>
</template>

<script>
import Vue from 'vue'
import { mapActions, mapGetters } from 'vuex'
import { userInfo } from 'os'
import LogoutFrom from '@/components/LogoutForm'

export default {
  name: 'Header',
  components:{
    LogoutFrom
  },
  computed: {
    ...mapGetters({
      userProfile: 'auth/userProfile',
      tenantDesignConfig: 'tenantDesign/config',
      userInfo: 'userDemographic/userInfo',
      isUserLoggedIn: 'auth/isUserAuthenticated',
      collections: 'productCatalog/collections',
      portalConfigurations: 'tenantDesign/config'
    }),
    portalGeneralInfo () {
      return this.portalConfigurations.general
    },
    showUnsubButton () {
      if (!this.portalConfigurations.header) {
        return true
      } else {
        return !this.portalConfigurations.header.hideUnsub
      }
    },
    tenantLoginType () {
      return this.tenantDesignConfig.userManagement.loginType.toLowerCase()
    },
    displayName () {
      return this.userInfo.username ? this.userInfo.username : this.userInfo.email
    }
  },
  created () {
    if (this.collections.length === 0) {
      this.loadCollections()
    }
    if (this.isUserLoggedIn) {
      this.loadUserInfo()
    }
  },
  mounted () {
    if (this.isUserLoggedIn) {
      this.loadUserInfo()
    }
  },
  methods: {
    ...mapActions({
      logout: 'auth/logout',
      initUnsub: 'subscription/initUnsub',
      loadCollections: 'productCatalog/loadCollections',
      showLogin: 'navigation/showLogin',
      showUnsub: 'navigation/showUnsub',
      loadUserInfo: 'userDemographic/loadUserInfo'
    }),
    login () {
      this.$ga.event('Registration', 'MenuLogin/Register')
      this.$router.push({ name: 'login' })
    }
  }
}
</script>
